import EnvironmentService from '@/env/EnvironmentService';
import { CountryCode } from 'libphonenumber-js';

export const useCountryFlag = function() {
  const countryFlag = (countryCode: CountryCode) => {
    return getFlagEmoji(countryCode || EnvironmentService.Environment.getAppDomainConfig().region);
  };

  function getFlagEmoji(countryCode: CountryCode): string {
    return String.fromCodePoint(...[...countryCode.toUpperCase()].map((code) => 0x1f1a5 + code.charCodeAt(0)));
  }
  return {
    countryFlag,
    getFlagEmoji,
  }
};
